import { cn } from '@/lib/cn';

interface MaterialIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Material Symbols ligature name, e.g. `volunteer_activism`, `schedule`. */
  name: string;
  /** Filled variant (uses font-variation-settings 'FILL' 1). */
  filled?: boolean;
}

/**
 * Material Symbols Outlined icon wrapper. The font is loaded globally from
 * Google Fonts in index.html; this component just renders the ligature span.
 */
export function MaterialIcon({ name, filled, className, style, ...rest }: MaterialIconProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('material-symbols-outlined', className)}
      style={filled ? { ...style, fontVariationSettings: "'FILL' 1" } : style}
      {...rest}
    >
      {name}
    </span>
  );
}
